import { Nav, Footer } from "@/components/Chrome";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold text-white mb-2">{title}</h2>
    <div className="font-mono text-sm text-[var(--muted)] leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <div className="relative text-[var(--text)] min-h-screen">
      <Nav />
      <main className="relative max-w-3xl mx-auto px-6 md:px-10 pt-28 pb-16" data-testid="terms-page">
        <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan mb-3">// LEGAL</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-white mb-3">Terms of Service</h1>
        <p className="font-mono text-xs text-[var(--muted)] mb-10">Last updated: 2026 · Plain-language summary of how Coretext works.</p>

        <Section title="What Coretext does">
          <p>Coretext audits AI-coding prompts, scores their readiness, and produces an intent-preserving optimized rewrite. Using the service means you accept these terms.</p>
        </Section>
        <Section title="Your account">
          <p>Creating a Coretext account lets you save your audit history and personal intelligence. You're responsible for keeping your login secure. Auditing is free within the stated limits.</p>
        </Section>
        <Section title="Optional Personalized Build Intelligence">
          <p>Coretext offers an <span className="text-white">optional</span> Personalized Build Intelligence feature. When you explicitly authorize a supported platform connection, Coretext can analyze your authorized build and prompt history to improve future audits, optimization, compression, and build recommendations.</p>
          <p><span className="text-neon-amber">Creating an account does NOT authorize access to any external platform.</span> That access requires separate, explicit permission via a platform connection screen.</p>
        </Section>
        <Section title="Acceptable use">
          <p>Don't use Coretext to submit content you don't have the right to, or to break the law. We may rate-limit or suspend abusive usage.</p>
        </Section>
        <Section title="No warranty on estimates">
          <p>Readiness scores, credit-savings estimates, and retention metrics are best-effort estimates, not guarantees. Always review the optimized prompt before sending it.</p>
        </Section>
        <Section title="Changes">
          <p>We may update these terms; material changes will be reflected here. Continued use means acceptance.</p>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
